import { render, staticRenderFns } from "./contactWay.vue?vue&type=template&id=509293ce"
import script from "./contactWay.vue?vue&type=script&lang=js"
export * from "./contactWay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports